import React, { useContext, useEffect, useState } from 'react'
import CargandoInicio from '../../components/CargandoInicio'
import ErrorRole from '../../components/ErrorRole'
import GeneralContext from '../../context/GeneralContext'
import * as Services from '../../utils/services'
import * as GeneralActions from '../../store/actions/generalActions'
import { Redirect } from 'react-router-dom'
import AuthService from '../../utils/auth/Auth.service';
import ReintentoServicio from '../../components/ReintentoServicio'
import * as GeneralRepository from "../../services/repositories/general-repository";
import * as UsuarioRepository from "../../services/repositories/usuario-repository";
import * as Constantes from '../../utils/constantes'

const Roles = ({ history }) => {
    const initialState = {
        errorCargando: null,
        estaCargando: true,
        usuario: null
    }

    const { dispatch: generalDispatch } = useContext(GeneralContext)
    const [ state, setState ] = useState(initialState)
    const [ reload, setReload ] = useState(false)
    const authService = new AuthService()

    const handleLogout = () => {
        authService.logout()
    }

    const handleReintento = async () => {
        if (state.errorCargando === Constantes.MENSAJE_ERROR_SERVICIO_401) {
            setState((state) => {
                return {
                    ...state,
                    estaCargandoProspectos: true
                }
            })
            let renueva = await authService.renovar()
            
            if (renueva) {
                try {
                    const resToken = await Services.getTokenAccess()
                    if(!resToken.error) {
                        generalDispatch(GeneralActions.updateToken(resToken.res.access_token))
                        setReload(true)
                        setState((state) => {
                            return {
                                ...state,
                                errorCargando: null,
                                reload: null
                            }
                        })
                    }
                } catch (error) {
                    console.error(error)
                }
            } else {
                handleReintento()
            }
        } else {
            setReload(!reload)
            setState({
                ...state,
                estaCargandoProspectos: true,
                errorCargando: null
            })
        }
    }

    const cargarDatosIniciales = async () => {
        const obtenerToken = async() => {
            const response = await GeneralRepository.obtenerAccessToken()
            if(response.error === null) {
                let usuario = {
                    token: {
                        token_type: response.token.token_type,
                        access_token: response.token.access_token
                    }
                }
                await obtenerRolesUsuario(usuario)
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            }
        }

        const obtenerRolesUsuario = async(usuario) => {
            const response = await UsuarioRepository.obtenerRoles()
            if(response.error === null) {
                let usuarioSalida = {
                    ...usuario,
                    roles: response.roles
                }
                await obtenerDatosUsuario(usuarioSalida)
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            }
        }

        const obtenerDatosUsuario = async(usuario) => {
            const response = await UsuarioRepository.obtenerDatosUsuario()
            if(response.error === null) {
                let usuarioSalida = {
                    ...usuario,
                    info: {
                        IdUsuario: response.datosUsuario.IdUsuario,
                        CodigoIntermediario: response.datosUsuario.CodigoIntermediario,
                        Nombres: response.datosUsuario.Nombres,
                        ApellidoPaterno: response.datosUsuario.ApellidoPaterno,
                        ApellidoMaterno: response.datosUsuario.ApellidoMaterno,
                        EmailInterno: response.datosUsuario.EmailInterno
                    }
                }
                setState((state) => {
                    return {
                        ...state,
                        estaCargando: false,
                        errorCargando: null,
                        usuario: usuarioSalida
                    }
                })
                generalDispatch(GeneralActions.guardarDatosUsuario(usuarioSalida))
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            }
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        await obtenerToken()
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }

    useEffect(() => {
        cargarDatosIniciales()
    }, [generalDispatch, reload])

    return (
        <React.Fragment>
            <CargandoInicio
                estaCargando={state.estaCargando} />
            <ReintentoServicio
                errorCargando={state.errorCargando}
                handleReintento={handleReintento}
                handleSalir={handleLogout}
                tipoMensaje={2} />

            {state.usuario !== null && state.usuario.info !== undefined && state.usuario.info !== null &&
                state.usuario.roles !== undefined
                    ? state.usuario.roles.length > 0
                        ? <Redirect to={{pathname: '/home'}}/>
                        : <ErrorRole
                            onclick={handleLogout} />
                    : null
            }            
        </React.Fragment>
    )
}

export default Roles